import { useSearchParams } from 'react-router-dom';
import url from '../../helpers/url';

const useCommon = () => {
    const [searchParams] = useSearchParams();

    /**
     * Decodes Base64-encoded URL search parameters into a key-value object.
     *
     * @template T - A union of string literals representing expected parameter keys.
     * @param {T[]} params - Array of search parameter keys to retrieve and decode.
     * @returns {Record<T, string | null>} An object with the original keys and their decoded values (or null if not found).
     */
    const getDecodedSearchParams = <T extends string>(params: T[]): Record<T, string | null> => {
        return params.reduce((acc, key) => {
            const value = searchParams.get(key) || url.getQuery(key);
            acc[key] = value !== null ? atob(value) : null;
            return acc;
        }, {} as Record<T, string | null>);
    };

    return { getDecodedSearchParams };
};

export default useCommon;
